import { selectCustomStyles } from 'components/common/Select';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AsyncPaginate } from 'react-select-async-paginate';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Controller, useForm } from 'react-hook-form';
import ErrorMessage from 'components/common/ErrorMessage';
import { useParams } from 'react-router-dom';
import { fetchCases } from 'slices/caseSlice';
import { moveMultipleCases } from 'slices/caseSlice';
import toast from 'react-hot-toast';
import { setError } from 'slices/caseSlice';
import Api from 'services/api';

function MoveCaseModal({
    isOpen,
    onClose,
    onConfirm,
    selectedItems,
    setSelectedItems,
    onCaseChange
}) {
    const { register, handleSubmit, watch, formState: { errors }, control, setValue, } = useForm();
    const dispatch = useDispatch();
    const { id: apptID } = useParams();

    // #region Appointment dropdown
    const [filterAppt, setFilterAppt] = useState(null)

    const filteredApptLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await Api.fetchAppointmentIds(
            page,
            { pageLength: 20, search: inputValue, exclude_id: apptID }
        );

        const data = result?.data?.data?.data ?? [];
        const lastPage = result?.data?.data?.last_page ?? 1;

        return {
            options: data.map(val => ({
                value: val.id,
                label: val.appid,
            })),
            hasMore: page < lastPage,
            additional: { page: page + 1 },
        };
    };
    //#endregion

      const submitCallback = (status, message) => {
        if (status) {
          toast.success(message, {
            className: "successToast",
          })
          dispatch(fetchCases(1, { appt_id: apptID }))
          onClose()
          setSelectedItems([])
          onCaseChange && onCaseChange()
        }
        else {
          console.log('onSubmit', message)
          toast.error(message,
            {
              className: "errorToast",
            }
          );
        }
      };
    

    const onSubmit = (data) => {
        dispatch(setError({}))

        const formData = {
            ...data,
            case_ids: selectedItems
        }
        dispatch(moveMultipleCases(formData, submitCallback));
    }

    return (
        <Modal isOpen={isOpen} toggle={onClose} centered>
            <form onSubmit={handleSubmit(onSubmit)}>
                <ModalHeader toggle={onClose}>Move Case</ModalHeader>
                <ModalBody>
                    <h2>Please Select a Appointment for move the selected case</h2>
                    <div className="row-primary  my-4">
                        <Controller
                            name="appt_id"
                            control={control}
                            rules={{
                                required: "Please select a appointment"
                            }}
                            render={({ field }) =>
                                <div className='w-100'>
                                    <AsyncPaginate
                                        menuPlacement='auto'
                                        styles={{ ...selectCustomStyles }}
                                        value={filterAppt}
                                        loadOptions={filteredApptLoadOptions}
                                        debounceTimeout={500}
                                        isClearable
                                        escapeClearsValue
                                        onChange={(obj) => {
                                            setFilterAppt(obj);
                                            field.onChange(obj?.value);
                                        }}
                                        additional={{ page: 1 }}
                                    />

                                    {errors?.state_id?.message &&
                                        <div style={{ marginBottom: 10 }}>
                                            <ErrorMessage text={errors?.state_id?.message} />
                                        </div>
                                    }

                                </div>
                            }
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="main_button" type='submit' onClick={onConfirm}>Move</button>
                    <button className="table_delete" type='button' onClick={onClose}>Cancel</button>
                </ModalFooter>
            </form>
        </Modal>
    );
}

export default MoveCaseModal
